import { IsNotEmpty, ValidateIf } from 'class-validator';

export class ExerciseFormData {
    @IsNotEmpty()
    name: string;

    @IsNotEmpty()
    group: string;
}
